export default __webpack_public_path__ + "static/media/staff-2022.cb1f8cd0.png";